import { pageMargin } from "./commonClassNames";
import { ChildrenOnlyProp } from "./commonProps";
import { linearGradientPrimary } from "./commonCss";

export const Subheader: React.FC<ChildrenOnlyProp> = ({ children }) => {
  const className = [pageMargin, "h-fit w-full flex flex-row"].join(" ");
  return (
    <div
      className={className}
      style={{
        background: linearGradientPrimary,
      }}
    >
      {children}
    </div>
  );
};
